(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lf-lead-popup"] && !Shopify.designMode) return;
  try {
    /* Películas Fácil: Reportana's official embed, isolated from the storefront. */
(function (window, document) {
  'use strict';

  if (window.LFLeadCapture && window.LFLeadCapture.submit) return;

  var SDK_URL = 'https://app.reportana.com/events.js?shop_id=21491';
  var STAGE_TIMEOUT_MS = 20000;
  var INTEREST_LISTS = Object.freeze({ automotivo: '96185', residencial: '96439', ppf: '96440' });
  var completed = new Set();
  var confirmedStages = new Set();
  var active = null;
  var sequence = 0;

  // No customer data, redirect token, or private credential is interpolated here.
  var FRAME_HTML = '<!doctype html><html><head><meta charset="utf-8">' +
    '<meta name="referrer" content="no-referrer"></head><body>' +
    '<form id="lf-rptn-form" method="POST" action="/" data-rptn-form="">' +
    '<input type="hidden" data-rptn-field="name" value="">' +
    '<input type="hidden" data-rptn-field="email" value="">' +
    '<input type="hidden" data-rptn-field="phone" value="">' +
    '</form><script async src="' + SDK_URL + '"><\/script></body></html>';

  function failure(code, message) {
    var error = new Error(message);
    error.code = code;
    return error;
  }

  function text(value, field, max) {
    if (value === undefined || value === null) return '';
    if (typeof value !== 'string') throw failure('VALIDATION', 'Confira o campo ' + field + '.');
    var result = value.trim();
    if (result.length > max || /[\u0000-\u001F\u007F]/.test(result)) {
      throw failure('VALIDATION', 'Confira o campo ' + field + '.');
    }
    return result;
  }

  function normalizePhone(value) {
    var raw = text(value, 'telefone', 40);
    if (!raw) return '';
    if (!/^\+?[\d\s().-]+$/.test(raw)) throw failure('VALIDATION', 'Informe um telefone válido com DDD.');
    var digits = raw.replace(/\D/g, '');
    if (raw.charAt(0) === '+') {
      if (!/^[1-9]\d{7,14}$/.test(digits)) throw failure('VALIDATION', 'Informe um telefone válido com código do país.');
      if (digits.slice(0, 2) === '55' && !/^55\d{10,11}$/.test(digits)) {
        throw failure('VALIDATION', 'Informe um telefone válido com DDD.');
      }
      return '+' + digits;
    }
    if (/^\d{10,11}$/.test(digits)) return '+55' + digits;
    if (/^55\d{10,11}$/.test(digits)) return '+' + digits;
    throw failure('VALIDATION', 'Informe um telefone válido com DDD.');
  }

  function normalize(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input)) {
      throw failure('VALIDATION', 'Confira os dados do cadastro.');
    }
    var email = text(input.email, 'e-mail', 254).toLowerCase();
    if (!/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email)) {
      throw failure('VALIDATION', 'Informe um e-mail válido.');
    }
    if (!Object.prototype.hasOwnProperty.call(INTEREST_LISTS, input.interest)) {
      throw failure('VALIDATION', 'Escolha o seu interesse.');
    }
    ['whatsapp', 'sms'].forEach(function (field) {
      if (input[field] !== undefined && typeof input[field] !== 'boolean') {
        throw failure('VALIDATION', 'Confira as autorizações de contato.');
      }
    });
    var phone = normalizePhone(input.phone);
    if ((input.whatsapp === true || input.sms === true) && !phone) {
      throw failure('VALIDATION', 'Informe seu telefone para receber mensagens.');
    }
    return {
      name: text(input.name, 'nome', 200), email: email, phone: phone,
      interest: input.interest, whatsapp: input.whatsapp === true, sms: input.sms === true
    };
  }

  function nonce() {
    sequence += 1;
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID() + '-' + sequence;
    }
    return Date.now().toString(36) + '-' + sequence + '-' + Math.random().toString(36).slice(2);
  }

  function sendStage(listId, lead) {
    return new Promise(function (resolve, reject) {
      var frame = document.createElement('iframe');
      var token = nonce();
      var successURL = 'about:blank#lf-success-' + token;
      var errorURL = 'about:blank#lf-error-' + token;
      var submitted = false;
      var settled = false;
      var timer;

      function finish(error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        frame.removeEventListener('load', onLoad);
        frame.removeEventListener('error', onFrameError);
        frame.remove();
        if (error) reject(error);
        else resolve();
      }

      function onFrameError() {
        finish(failure('SDK_LOAD', 'Não foi possível carregar o cadastro. Tente novamente.'));
      }

      function onLoad() {
        if (settled) return;
        try {
          var frameWindow = frame.contentWindow;
          var currentURL = frameWindow.location.href;
          if (submitted) {
            if (currentURL === successURL) finish();
            else if (currentURL === errorURL) {
              finish(failure('SUBMISSION', 'Não foi possível confirmar o cadastro. Tente novamente.'));
            }
            return;
          }

          // Ignore the initial empty document; wait for srcdoc and its async SDK.
          if (currentURL !== 'about:srcdoc') return;
          var frameDocument = frame.contentDocument;
          var form = frameDocument.getElementById('lf-rptn-form');
          if (!form || frameWindow.rptnEventsScriptLoaded !== true) {
            onFrameError();
            return;
          }
          if (typeof form.requestSubmit !== 'function') {
            finish(failure('UNSUPPORTED', 'Atualize seu navegador para concluir o cadastro.'));
            return;
          }
          form.setAttribute('data-rptn-form', listId);
          form.setAttribute('data-rptn-thank-you-page', successURL);
          form.setAttribute('data-rptn-error-page', errorURL);
          ['name', 'email', 'phone'].forEach(function (field) {
            form.querySelector('[data-rptn-field="' + field + '"]').value = lead[field];
          });
          // Prevent a native navigation even if the SDK changes; keep bubbling.
          form.addEventListener('submit', function (event) { event.preventDefault(); });
          submitted = true;
          form.requestSubmit();
        } catch (error) {
          finish(failure('FRAME_ACCESS', 'Não foi possível confirmar o cadastro. Tente novamente.'));
        }
      }

      frame.hidden = true;
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('title', 'Cadastro Películas Fácil');
      frame.setAttribute('referrerpolicy', 'no-referrer');
      frame.addEventListener('load', onLoad);
      frame.addEventListener('error', onFrameError);
      frame.srcdoc = FRAME_HTML;
      timer = window.setTimeout(function () {
        finish(failure('TIMEOUT', 'O cadastro demorou para responder. Tente novamente.'));
      }, STAGE_TIMEOUT_MS);
      try {
        if (!document.body) throw new Error('document not ready');
        document.body.appendChild(frame);
      } catch (error) {
        finish(failure('NOT_READY', 'Aguarde o carregamento da página e tente novamente.'));
      }
    });
  }

  async function capture(lead) {
    var lists = [];
    if (lead.whatsapp) lists.push('96441');
    if (lead.sms) lists.push('96442');
    lists.push(INTEREST_LISTS[lead.interest]);
    for (var i = 0; i < lists.length; i += 1) {
      var stageKey = JSON.stringify([lead.email, lead.phone, lead.name, lists[i]]);
      if (confirmedStages.has(stageKey)) continue;
      await sendStage(lists[i], lead);
      confirmedStages.add(stageKey);
    }
    return { ok: true };
  }

  function submit(input) {
    var lead;
    try { lead = normalize(input); }
    catch (error) { return Promise.reject(error); }
    var key = JSON.stringify(lead);
    if (active) {
      if (active.key === key) return active.promise;
      return Promise.reject(failure('BUSY', 'Um cadastro já está em andamento. Aguarde.'));
    }
    if (completed.has(key)) return Promise.resolve({ ok: true });
    var promise = capture(lead).then(function (result) {
      completed.add(key);
      return result;
    });
    active = { key: key, promise: promise };
    function release() { if (active && active.promise === promise) active = null; }
    promise.then(release, release);
    return promise;
  }

  window.LFLeadCapture = Object.freeze({ submit: submit });
})(window, document);


(() => {
  const root = document.querySelector('[data-lf-lead-popup]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const dialog = root.querySelector('dialog');
  if (typeof dialog.showModal !== 'function') return;
  const find = (selector) => root.querySelector(selector);
  const form = find('[data-lf-form]');
  const launcher = find('[data-lf-open]');
  const email = find('[name="email"]');
  const interest = find('[name="interest"]');
  const phone = find('[name="phone"]');
  const submit = find('[data-lf-submit]');
  const error = find('[data-lf-error]');
  const status = find('[data-lf-status]');
  const messages = find('[data-lf-messages]').dataset;
  const category = find('[data-lf-category]');
  const storageKeys = { closed: 'lf_lead_closed_until_v1', success: 'lf_lead_success_until_v1', seen: 'lf_lead_seen_v2' };
  const categories = {
    automotivo: 'https://peliculasfacil.com.br/collections/pelicula-automotiva-nanoceramica',
    residencial: 'https://peliculasfacil.com.br/collections/pelicula-residencial-nanoceramica',
    ppf: 'https://peliculasfacil.com.br/collections/ppf-automotivo-pelicula-protecao-pintura'
  };
  let busy = false;
  let completed = false;
  let shown = false;
  let elapsed = false;
  let checkingCart = false;
  let autoStopped = false;
  let returnFocus = null;
  let previousOverflow = '';
  const readStorage = (type, key) => { try { return window[type].getItem(key); } catch { return null; } };
  const writeStorage = (type, key, value) => { try { window[type].setItem(key, String(value)); } catch {} };
  const activeUntil = (key) => Number(readStorage('localStorage', key)) > Date.now();
  const suppressed = () => activeUntil(storageKeys.closed) || activeUntil(storageKeys.success);
  const announceError = (message, field) => {
    error.textContent = message;
    error.hidden = false;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
  };
  const clearError = () => {
    error.hidden = true;
    error.textContent = '';
    [email, phone, interest].forEach((field) => field.removeAttribute('aria-invalid'));
  };
  const normalizePhone = (value) => {
    let digits = value.replace(/\D/g, '');
    if (digits.length === 13 && digits.startsWith('55')) digits = digits.slice(2);
    const ddds = '11 12 13 14 15 16 17 18 19 21 22 24 27 28 31 32 33 34 35 37 38 41 42 43 44 45 46 47 48 49 51 53 54 55 61 62 63 64 65 66 67 68 69 71 73 74 75 77 79 81 82 83 84 85 86 87 88 89 91 92 93 94 95 96 97 98 99'.split(' ');
    return /^\d{2}9\d{8}$/.test(digits) && ddds.includes(digits.slice(0, 2)) ? '+55' + digits : null;
  };
  const stopAuto = () => { autoStopped = true; window.removeEventListener('scroll', tryAuto); };
  const open = () => {
    if (dialog.open || completed || activeUntil(storageKeys.success)) return;
    returnFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    shown = true;
    writeStorage('sessionStorage', storageKeys.seen, '1');
    stopAuto();
    email.focus();
  };
  const close = () => {
    if (!dialog.open) return;
    if (!completed) writeStorage('localStorage', storageKeys.closed, Date.now() + 7 * 86400000);
    dialog.close();
  };
  launcher.hidden = activeUntil(storageKeys.success);
  launcher.addEventListener('click', open);
  find('[data-lf-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (returnFocus && returnFocus.isConnected && typeof returnFocus.focus === 'function') returnFocus.focus();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex="0"]')].filter((element) => !element.closest('[hidden]') && element.getClientRects().length);
    if (!focusable.length) { event.preventDefault(); return; }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  [email, phone, interest].forEach((field) => field.addEventListener('input', () => field.removeAttribute('aria-invalid')));
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy || completed) return;
    clearError();
    email.value = email.value.trim();
    if (!email.value || !email.checkValidity()) { announceError(messages.email, email); return; }
    const normalizedPhone = normalizePhone(phone.value);
    if (!normalizedPhone) { announceError(messages.phone, phone); return; }
    if (!Object.hasOwn(categories, interest.value)) { announceError(messages.interest, interest); return; }
    const adapter = window.LFLeadCapture;
    if (!adapter || typeof adapter.submit !== 'function') { announceError(messages.unavailable); return; }
    const payload = { name: '', email: email.value, phone: normalizedPhone, interest: interest.value, whatsapp: true, sms: true };
    busy = true; submit.disabled = true; form.setAttribute('aria-busy', 'true'); status.textContent = messages.busy;
    const controls = [...form.querySelectorAll('input, select, button')];
    controls.forEach((control) => { control.disabled = true; });
    try {
      const result = await adapter.submit(payload);
      if (!result || result.ok !== true) throw new Error('CAPTURE_NOT_CONFIRMED');
      completed = true;
      writeStorage('localStorage', storageKeys.success, Date.now() + 90 * 86400000);
      launcher.hidden = true;
      form.hidden = true;
      find('[data-lf-coupon]').textContent = 'BEMVINDO5';
      find('[data-lf-success]').hidden = false;
      category.href = categories[payload.interest];
      status.textContent = messages.success;
      form.reset();
      if (dialog.open) find('[data-lf-success-title]').focus();
    } catch {
      status.textContent = '';
      announceError(messages.failed);
    } finally {
      busy = false; controls.forEach((control) => { control.disabled = false; }); form.removeAttribute('aria-busy');
    }
  });
  find('[data-lf-copy]').addEventListener('click', async () => {
    if (!completed) return;
    try { await navigator.clipboard.writeText(find('[data-lf-coupon]').textContent); status.textContent = messages.copied; }
    catch { status.textContent = messages.copyFallback; const range = document.createRange(); range.selectNodeContents(find('[data-lf-coupon]')); const selected = window.getSelection(); selected.removeAllRanges(); selected.addRange(range); }
  });
  const hasVisibleModal = () => [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some((element) => {
    if (element.closest('[hidden], [aria-hidden="true"], details:not([open])')) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility === 'visible' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && rect.left < window.innerWidth && rect.right > 0 && rect.top < window.innerHeight && rect.bottom > 0;
  });
  async function tryAuto() {
    if (autoStopped || checkingCart || shown || !elapsed || root.dataset.autoAllowed !== 'true' || suppressed() || readStorage('sessionStorage', storageKeys.seen) === '1' || document.visibilityState !== 'visible') return;
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0 || window.scrollY / scrollable < 0.3) return;
    if (hasVisibleModal() || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
    checkingCart = true;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 3500);
    try {
      const response = await fetch(root.dataset.cartUrl, { method: 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) { stopAuto(); return; }
      const currentCart = await response.json();
      if (!Number.isFinite(currentCart.item_count) || currentCart.item_count !== 0) { stopAuto(); return; }
      if (!autoStopped && !shown && !suppressed() && document.visibilityState === 'visible' && !hasVisibleModal() && !document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) open();
    } catch { stopAuto(); }
    finally { window.clearTimeout(timeout); checkingCart = false; }
  }
  window.addEventListener('scroll', tryAuto, { passive: true });
  window.setTimeout(() => { elapsed = true; tryAuto(); }, 12000);
  window.LFLeadPopup = { open, close };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const mediaItems = document.querySelectorAll('.product__media--item');
    const modal = document.querySelector('.product__modal');
    const modalWrapper = document.querySelector('.product__modal--wrapper');
    const modalMediaItems = document.querySelectorAll('.product__modal__media--item');
    const arrowLeft = document.querySelector('.product__modal .arrow-left');
    const arrowRight = document.querySelector('.product__modal .arrow-right');
    let currentIndex = 0;

    function openModal(index) {
      if (modal) modal.style.display = 'flex';
      document.querySelector('html').style.overflow = 'hidden';
      modalMediaItems?.forEach((item, i) => {
        item.style.display = i === index ? 'block' : 'none';
      });
      currentIndex = index;
    }

    function closeModal() {
      modal.style.display = 'none';
      document.querySelector('html').style.overflow = 'auto';
    }

    mediaItems?.forEach((item, i) => {
      item.addEventListener('click', () => {
        openModal(i);
      });
    });

    modal?.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (modal && modal.style.display === 'flex') {
        if (e.key === 'ArrowRight') {
          currentIndex = (currentIndex + 1) % modalMediaItems.length;
          openModal(currentIndex);
        }
        if (e.key === 'ArrowLeft') {
          currentIndex = (currentIndex - 1 + modalMediaItems.length) % modalMediaItems.length;
          openModal(currentIndex);
        }
        if (e.key === 'Escape') {
          closeModal();
        }
      }
    });

    arrowLeft?.addEventListener('click', function (e) {
      e.stopPropagation();
      currentIndex = (currentIndex - 1 + modalMediaItems.length) % modalMediaItems.length;
      openModal(currentIndex);
    });

    arrowRight?.addEventListener('click', function (e) {
      e.stopPropagation();
      currentIndex = (currentIndex + 1) % modalMediaItems.length;
      openModal(currentIndex);
    });

    const swiperThumbs = new Swiper('.swipper-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swiper = new Swiper('.swipper-container', {
      loop: true,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 5000,
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  });
  } catch(e) { console.error(e); }
})();

})();
